import {createRootContextHook} from 'common/util/react';

/**
 * A hook that re-renders the component when the current language changes.
 */
export const useTranslation = createRootContextHook(`i18n`);
